import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Typography } from '@mui/material';
import { object, string } from 'prop-types';
import React, { useEffect } from 'react';
import { I18n } from 'utils/i18n';
import { getEmbedParentTargetOrigin } from 'utils/webOrigin';

const SuccessView = ({ signatureRequest = null, onComplete }) => {
  // Send message to parent window/app to close modal after 2.5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      const message = {
        type: 'OMMNIOSIGN_COMPLETE',
        requestId: signatureRequest?.requestId,
        externalId: signatureRequest?.externalId, // messageId (if Ommnio delivery)
        externalType: signatureRequest?.externalType,
      };

      // Use callback if provided (for embedded use), otherwise use postMessage (for iframe/route use)
      if (onComplete) {
        onComplete(message);
      } else if (window.ReactNativeWebView?.postMessage) {
        window.ReactNativeWebView.postMessage(JSON.stringify(message));
      } else if (window.parent !== window) {
        // We're in an iframe - send to parent window
        window.parent.postMessage(message, getEmbedParentTargetOrigin());
      }
    }, 2500);

    return () => clearTimeout(timer);
  }, [signatureRequest, onComplete]);

  return (
    <Box
      sx={{
        p: 4,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 300,
      }}
    >
      <CheckCircleIcon sx={{ fontSize: 100, color: 'success.main', mb: 3 }} />

      <Typography variant="h4" gutterBottom>
        {I18n.t('OmmnioSign.Success.Title')}
      </Typography>

      <Typography variant="body1" color="textSecondary">
        {I18n.t('OmmnioSign.Success.Description')}
      </Typography>
    </Box>
  );
};

SuccessView.propTypes = {
  signatureRequest: object,
  signatureDetails: object,
  evidenceId: string,
};

export default SuccessView;
